import { createContext } from 'react'
import type { useTooltip } from './hooks'

export const TooltipContext = createContext<ReturnType<
  typeof useTooltip
> | null>(null)
